import * as go from 'gojs';
import { EMOJI_PROP } from '../common/config/common-prop-names';
import { locationBinding, lockedBindings } from '../common/utils/bindings';
import { EMOJI_LAYER_NAME } from './config/part-names';

const $ = go.GraphObject.make;
const movable = true;
const resizable = false;
const rotatable = false;

export const emojiNodeTemplate = () =>
  $(
    go.Node,
    go.Node.Auto,
    {
      isLayoutPositioned: false,
      locationSpot: go.Spot.Center,
      toolTip: null,
      copyable: false,
      layerName: EMOJI_LAYER_NAME,
    },
    $(
      go.TextBlock,
      {
        font: '50px sans-serif',
        editable: false,
        margin: new go.Margin(8, 0, 0, 0),
      },
      new go.Binding('text', EMOJI_PROP),
    ),
    locationBinding(),
    ...lockedBindings({ movable, resizable, rotatable }),
  );
